define("shared/components/shared/profile-avatar", ["exports", "@ember/component", "@ember/template-factory", "ember-concurrency/-private/async-arrow-runtime", "@ember/object", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/helpers/profile-color-outline-class", "later/utils/object-promise-proxy"], function (_exports, _component, _templateFactory, _asyncArrowRuntime, _object, _component2, _tracking, _emberConcurrency, _profileColorOutlineClass, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/-private/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/helpers/profile-color-outline-class",0,"later/utils/object-promise-proxy"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    class="{{this.sizeClass}}
      {{this.outlineClass}}
      {{this.disabledClass}}
      qa--creator_join_db_social_profiles_{{@socialProfile.platformAbbreviation}}"
    data-profile-type={{@socialProfile.platformAbbreviation}}
    data-uid={{@socialProfile.uid}}
    ...attributes
    {{did-insert this.setInitialAvatarUrl}}
  >
    {{#if this.avatarUrl}}
      <span class="o--user__avatarProfile">
        <img
          alt={{@socialProfile.displayNickname}}
          class="o--user__avatar {{@avatarClass}}"
          data-test-avatar
          draggable="false"
          ondragstart="return false;"
          onerror={{perform this.handleError}}
          src={{this.avatarUrl}}
        />
      </span>
    {{else}}
      <span>
        <img
          alt={{@socialProfile.displayNickname}}
          class="o--user__avatar {{@avatarClass}}"
          data-test-avatar-placeholder
          draggable="false"
          ondragstart="return false;"
          src="/assets/images/img--userAvatar--placeholder.svg"
        />
      </span>
    {{/if}}
  
    {{#if @showPlatform}}
      <span class={{concat "o--user__avatarChild--" @socialProfile.cssHandle}} data-test-id="platform-icon">
        <i class={{concat "i--" @socialProfile.cssHandle "--w"}}></i>
      </span>
    {{/if}}
  
    {{#if @showDetails}}
      <span class="o--user__title" data-test-id="nickname">
        <span class="u--ellipsis {{@handleQaClass}}">
          {{@socialProfile.displayNickname}}
        </span>
      </span>
      <span class={{concat-classes "o--user__desc" @userDescriptionClass}} data-test-id="description">
        {{@socialProfile.accountType}}
        {{#if @showProfileType}}
          |
          {{if @socialProfile.isLinkedinPersonalProfile (t "shared_words.profile") (t "linkedin.page")}}
        {{/if}}
      </span>
    {{/if}}
  
    {{yield}}
  </div>
  */
  {
    "id": "74z3oY4q",
    "block": "[[[11,0],[16,0,[29,[[30,0,[\"sizeClass\"]],\"\\n    \",[30,0,[\"outlineClass\"]],\"\\n    \",[30,0,[\"disabledClass\"]],\"\\n    qa--creator_join_db_social_profiles_\",[30,1,[\"platformAbbreviation\"]]]]],[16,\"data-profile-type\",[30,1,[\"platformAbbreviation\"]]],[16,\"data-uid\",[30,1,[\"uid\"]]],[17,2],[4,[38,0],[[30,0,[\"setInitialAvatarUrl\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"avatarUrl\"]],[[[1,\"    \"],[10,1],[14,0,\"o--user__avatarProfile\"],[12],[1,\"\\n      \"],[10,\"img\"],[15,\"alt\",[30,1,[\"displayNickname\"]]],[15,0,[29,[\"o--user__avatar \",[30,3]]]],[14,\"data-test-avatar\",\"\"],[14,\"draggable\",\"false\"],[14,\"ondragstart\",\"return false;\"],[15,\"onerror\",[28,[37,2],[[30,0,[\"handleError\"]]],null]],[15,\"src\",[30,0,[\"avatarUrl\"]]],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,1],[12],[1,\"\\n      \"],[10,\"img\"],[15,\"alt\",[30,1,[\"displayNickname\"]]],[15,0,[29,[\"o--user__avatar \",[30,3]]]],[14,\"data-test-avatar-placeholder\",\"\"],[14,\"draggable\",\"false\"],[14,\"ondragstart\",\"return false;\"],[14,\"src\",\"/assets/images/img--userAvatar--placeholder.svg\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[30,4],[[[1,\"    \"],[10,1],[15,0,[28,[37,3],[\"o--user__avatarChild--\",[30,1,[\"cssHandle\"]]],null]],[14,\"data-test-id\",\"platform-icon\"],[12],[1,\"\\n      \"],[10,\"i\"],[15,0,[28,[37,3],[\"i--\",[30,1,[\"cssHandle\"]],\"--w\"],null]],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,5],[[[1,\"    \"],[10,1],[14,0,\"o--user__title\"],[14,\"data-test-id\",\"nickname\"],[12],[1,\"\\n      \"],[10,1],[15,0,[29,[\"u--ellipsis \",[30,6]]]],[12],[1,\"\\n        \"],[1,[30,1,[\"displayNickname\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[15,0,[28,[37,4],[\"o--user__desc\",[30,7]],null]],[14,\"data-test-id\",\"description\"],[12],[1,\"\\n      \"],[1,[30,1,[\"accountType\"]]],[1,\"\\n\"],[41,[30,8],[[[1,\"        |\\n        \"],[1,[52,[30,1,[\"isLinkedinPersonalProfile\"]],[28,[37,5],[\"shared_words.profile\"],null],[28,[37,5],[\"linkedin.page\"],null]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[18,9,null],[1,\"\\n\"],[13]],[\"@socialProfile\",\"&attrs\",\"@avatarClass\",\"@showPlatform\",\"@showDetails\",\"@handleQaClass\",\"@userDescriptionClass\",\"@showProfileType\",\"&default\"],false,[\"did-insert\",\"if\",\"perform\",\"concat\",\"concat-classes\",\"t\",\"yield\"]]",
    "moduleName": "shared/components/shared/profile-avatar.hbs",
    "isStrictMode": false
  });

  let ProfileAvatarComponent = (_class = class ProfileAvatarComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "isError", _descriptor, this);

      _initializerDefineProperty(this, "_initialAvatarUrl", _descriptor2, this);

      _defineProperty(this, "handleError", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this._initialAvatarUrl = this.socialProfile?.get('secureAvatarUrl');
          this.isError = true;
          const socialProfile = yield (0, _objectPromiseProxy.default)(this.socialProfile);

          if (socialProfile && socialProfile.refreshProfile && typeof socialProfile.refreshProfile === 'function') {
            socialProfile.get('refreshAndReload').perform();
          }
        }
      }), null, "handleError", null));
    }

    get socialProfile() {
      return this.args.socialProfile;
    }

    get avatarUrl() {
      const url = this.socialProfile?.get('secureAvatarUrl');

      if (!this.isError) {
        return url;
      }

      return this._initialAvatarUrl !== url ? url : undefined;
    }

    get disabledClass() {
      return this.args.isDisabled ? 'u--mute' : '';
    }

    get outlineClass() {
      if (!this.args.showOutline || !this.socialProfile?.get('profileColorClass')) {
        return '';
      }

      return (0, _profileColorOutlineClass.profileColorOutlineClass)([this.socialProfile.get('profileColorClass')]);
    }

    get sizeClass() {
      const sizeClasses = {
        small: 'o--user--sm',
        medium: 'o--user',
        large: 'o--user--lg',
        default: 'o--user'
      };

      if (this.args.size) {
        return sizeClasses[this.args.size] || sizeClasses.default;
      }

      return sizeClasses.default;
    }

    setInitialAvatarUrl() {
      this._initialAvatarUrl = this.socialProfile?.get('secureAvatarUrl');
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_initialAvatarUrl", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "setInitialAvatarUrl", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setInitialAvatarUrl"), _class.prototype)), _class);
  _exports.default = ProfileAvatarComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProfileAvatarComponent);
});